import Card from './ui/Card';
import Icon from './ui/Icon';
import Reveal from './ui/Reveal';
import { transformations } from '../data/content';

export default function Program() {
  return (
    <section id="program">
      <div className="wrap">
        <div className="split rev text-wide">
          <Reveal as="figure" className="split-media media">
            <img
              className="media-img portrait"
              src="/mustapha-conference.jpg"
              width="624"
              height="780"
              loading="lazy"
              decoding="async"
              alt="Captain Mustapha Zehhaf presenting on LNG shipping at an industry conference"
            />
          </Reveal>

          <Reveal delay={1}>
            <span className="eyebrow">The LNG Ready program</span>
            <h2 className="h-sec">
              20 Years of Experience.
              <br />
              One Coaching Program.
            </h2>
            <p className="mt-m">
              LNG Ready is a <b>six-week live coaching program</b> designed for ambitious LNG
              professionals — not a self-paced video course. You&rsquo;ll progress alongside a small
              cohort with direct guidance from Captain Mustapha, developing the confidence, technical
              judgment, and practical skills required to advance your career.
            </p>
            <p>
              The goal isn&rsquo;t simply to know more. It&rsquo;s to think more clearly, communicate
              more confidently, and perform at the level expected of today&rsquo;s LNG professionals.
            </p>
          </Reveal>
        </div>

        <Reveal className="center narrow" style={{ marginTop: 96, marginInline: 'auto' }}>
          <span className="eyebrow">The transformation</span>
          <h3 className="h-sec">The professional you&rsquo;ll become.</h3>
          <p className="lede mt-m">
            Every part of LNG Ready is designed to help you build the confidence, technical
            judgment, and professional capability expected of today&rsquo;s LNG professionals.
          </p>
        </Reveal>

        <div className="grid4 mt-l">
          {transformations.map((item, i) => (
            <Reveal key={item.title} delay={i}>
              <Card>
                <div className="ic-tile">
                  <Icon name={item.icon} />
                </div>
                <h3>{item.title}</h3>
                <p className="card-lead">{item.lead}</p>
                <p>{item.body}</p>
              </Card>
            </Reveal>
          ))}
        </div>

        <Reveal className="center mt-l">
          <a className="btn btn-primary btn-lg" href="#pricing">
            Join the Program
          </a>
        </Reveal>
      </div>
    </section>
  );
}
